'use strict';

// Grid types could support layout persistence
module.exports = {
  GRIDVIEW: 'gridview', // layout persistence implemented
  ATTRIBUTES: 'attributes',
  COMPETITOR_MATCHES: 'competitor_matches',
  ENGINE_INPUTS: 'engine_inputs',
  PRICE_OVERRIDES: 'price_overrides',
  ANCHOR_MARGINS: 'anchor_margins',
};
